(function () {
  const DEFAULT_SPEED_SECONDS = 80;
  const MAX_REPEAT = 12;

  function readSpeed(root) {
    const section = root.closest('[data-benefit-marquee-speed]') || root.closest('.home-benefits');
    const raw = section && section.getAttribute('data-benefit-marquee-speed');
    const value = Number(raw);
    if (!Number.isFinite(value)) return DEFAULT_SPEED_SECONDS;
    return Math.min(120, Math.max(20, value));
  }

  function isEnabled(root) {
    const section = root.closest('[data-benefit-marquee-enabled]') || root.closest('.home-benefits');
    if (!section) return true;
    const raw = section.getAttribute('data-benefit-marquee-enabled');
    return raw !== 'false';
  }

  function initMarquee(root) {
    const viewport = root.querySelector('.benefit-marquee-viewport');
    const track = root.querySelector('.benefit-marquee-track');
    const primaryGroup = root.querySelector('.benefit-marquee-group--primary');

    if (!viewport || !track || !primaryGroup) return;

    const originals = Array.from(primaryGroup.querySelectorAll('.benefit-marquee-item'));
    if (!originals.length) return;

    const enabled = isEnabled(root);
    const speedSeconds = readSpeed(root);
    track.style.setProperty('--benefit-marquee-speed', speedSeconds + 's');

    if (!enabled) {
      track.querySelectorAll('.benefit-marquee-group--clone').forEach((node) => node.remove());
      track.setAttribute('data-ready', 'false');
      track.style.removeProperty('--benefit-marquee-distance');
      return;
    }

    const removeClones = () => {
      track.querySelectorAll('.benefit-marquee-group--clone').forEach((node) => node.remove());
    };

    const resetPrimary = () => {
      primaryGroup.querySelectorAll('.benefit-marquee-item').forEach((item, index) => {
        if (index >= originals.length) item.remove();
      });
    };

    const appendOriginalsToPrimary = () => {
      originals.forEach((item) => {
        primaryGroup.appendChild(item.cloneNode(true));
      });
    };

    const buildCloneGroup = () => {
      const cloneGroup = primaryGroup.cloneNode(true);
      cloneGroup.classList.remove('benefit-marquee-group--primary');
      cloneGroup.classList.add('benefit-marquee-group--clone');
      cloneGroup.setAttribute('aria-hidden', 'true');
      cloneGroup.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      return cloneGroup;
    };

    const measure = () => {
      const width = primaryGroup.scrollWidth;
      if (width > 0) {
        track.style.setProperty('--benefit-marquee-distance', width + 'px');
        track.setAttribute('data-ready', 'true');
      } else {
        track.setAttribute('data-ready', 'false');
      }
      return width;
    };

    const fillTrack = () => {
      removeClones();
      resetPrimary();
      track.setAttribute('data-ready', 'false');

      let repeatCount = 1;
      appendOriginalsToPrimary();
      repeatCount = 2;

      let width = measure();
      const target = viewport.clientWidth * 2;

      while (width < target && repeatCount < MAX_REPEAT) {
        appendOriginalsToPrimary();
        repeatCount += 1;
        width = measure();
      }

      track.appendChild(buildCloneGroup());
      measure();
    };

    let filling = false;
    const safeFillTrack = () => {
      if (filling) return;
      filling = true;
      try {
        fillTrack();
      } finally {
        filling = false;
      }
    };

    safeFillTrack();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(safeFillTrack);
      observer.observe(viewport);
    } else {
      window.addEventListener('resize', safeFillTrack, { passive: true });
    }
  }

  document.querySelectorAll('.benefit-marquee').forEach(initMarquee);
})();
